module.exports = __webpack_public_path__ + "img/lang-open.7b6e52f.png";